//@flow
import * as React from 'react'
import type { HarmoniaQualityReview$Props } from './flowTypes'
import ContainerRowExpandPanel from '../../components/common/ContainerRowExpandPanel'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'

const HarmoniaQualityReview=(props:HarmoniaQualityReview$Props)=>{
    const harmonia = props.harmonia
    let isVisible = false

    if (harmonia.reviewQuestions && harmonia.reviewQuestions.length > 0){
        isVisible = true
    }
    
    return (
        <ContainerRowExpandPanel visible={isVisible} 
        title={'Final Review Before Submission'} elementId={'harmoniaQualityReview'} 
        errors={props.noOfErros}
        >
            <QualityReviewContainer 
                elementId={'harmoniaPanelReviewQuestion'} 
                changeFieldValue={props.changeFieldValue} 
                questions={(harmonia.reviewQuestions:any)} 
            />
        </ContainerRowExpandPanel>
    )
}

export default HarmoniaQualityReview


// WEBPACK FOOTER //
// ./src/views/ProjectHarmonia/HarmoniaQualityReview.js